var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-breadcrumb',{staticClass:"breadcrumb",attrs:{"separator":"/"}},[_c('div',{staticClass:"breadcrumb-box"},[_c('el-breadcrumb-item',[_vm._v(_vm._s(this.$store.state.Navhighlighted.Plabel))]),_c('el-breadcrumb-item',[_vm._v(_vm._s(this.$store.state.Navhighlighted.label))])],1),_c('div',{staticClass:"user"},[_c('my-user')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }